var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.584 18.226h9.832a1.88 1.88 0 0 0 1.88-1.88v-6.072a1.88 1.88 0 0 0-1.493-1.84v-2.74A5.31 5.31 0 0 0 7.5.39a5.31 5.31 0 0 0-5.302 5.302v2.741a1.88 1.88 0 0 0-1.494 1.84v6.072a1.88 1.88 0 0 0 1.88 1.88m4.917-15.07a2.54 2.54 0 0 0-2.536 2.536v2.7h5.072v-2.7A2.54 2.54 0 0 0 7.5 3.156M7.5 11.224a1.664 1.664 0 0 0-.83 3.104v1.85h1.66v-1.85a1.662 1.662 0 0 0-.83-3.104",
    clipRule: "evenodd"
  })));
};
export default SvgPadlock;